exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-msg {\n  color: #a94442;\n}\n.fix-error-icon {\n  top: 27px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/staging.theprintlife.com/src/app/mnt-master/field-error-display/field-error-display.component.css
// module id = ../../../../../src/app/mnt-master/field-error-display/field-error-display.component.css
// module chunks = main